import { apiClient } from './api'
import type {
  CheckLinkageRequest,
  CreateExternalCrRequest,
  CustodyAction,
  CustodyDocument,
  DestroyEvidenceRequest,
  ExternalCrOutput,
  LinkageCheckResult,
  ListCustodyActionsParams,
  PaginatedCustodyActions,
  ReceiveEvidenceRequest,
  RelocateEvidenceRequest,
  ReturnEvidenceRequest,
  StoreEvidenceRequest,
} from '../types/custody-actions'

function buildQueryString(params: object): string {
  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  }
  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

export async function listCustodyActions(
  caseId: string,
  params?: ListCustodyActionsParams
): Promise<PaginatedCustodyActions> {
  const query = params ? buildQueryString(params) : ''
  return apiClient.get<PaginatedCustodyActions>(`/cases/${caseId}/custody-actions${query}`)
}

export async function getCustodyAction(caseId: string, actionId: string): Promise<CustodyAction> {
  return apiClient.get<CustodyAction>(`/cases/${caseId}/custody-actions/${actionId}`)
}

export async function getCustodyDocument(
  caseId: string,
  actionId: string
): Promise<CustodyDocument> {
  return apiClient.get<CustodyDocument>(`/cases/${caseId}/custody-actions/${actionId}/document`)
}

export async function checkCollectionLinkage(
  caseId: string,
  input: CheckLinkageRequest
): Promise<LinkageCheckResult> {
  return apiClient.post<LinkageCheckResult>(
    `/cases/${caseId}/custody-actions/receive/check-linkage`,
    input
  )
}

export async function createExternalCollectionRequest(
  caseId: string,
  input: CreateExternalCrRequest
): Promise<ExternalCrOutput> {
  return apiClient.post<ExternalCrOutput>(
    `/cases/${caseId}/custody-actions/receive/create-external-cr`,
    input
  )
}

export async function performReceive(
  caseId: string,
  input: ReceiveEvidenceRequest
): Promise<CustodyAction> {
  return apiClient.post<CustodyAction>(`/cases/${caseId}/custody-actions/receive`, input)
}

export async function performStore(
  caseId: string,
  input: StoreEvidenceRequest
): Promise<CustodyAction> {
  return apiClient.post<CustodyAction>(`/cases/${caseId}/custody-actions/store`, input)
}

export async function performRelocate(
  caseId: string,
  input: RelocateEvidenceRequest
): Promise<CustodyAction> {
  return apiClient.post<CustodyAction>(`/cases/${caseId}/custody-actions/relocate`, input)
}

export async function performReturn(
  caseId: string,
  input: ReturnEvidenceRequest
): Promise<CustodyAction> {
  return apiClient.post<CustodyAction>(`/cases/${caseId}/custody-actions/return`, input)
}

export async function performDestroy(
  caseId: string,
  input: DestroyEvidenceRequest
): Promise<CustodyAction> {
  return apiClient.post<CustodyAction>(`/cases/${caseId}/custody-actions/destroy`, input)
}
